<template>
	<div class="se_all">
		<div class="news_pc" v-if="!isPhone">
			<div class="page_tit" data-aos="fade-up">
				<p class="nc_p1">2020版剑南春全新防伪体系</p>
				<p class="nc_p2">2020版剑南春采用了三位一体的防伪技术，从外箱、外盒、瓶体三个环节运用防伪技术保障产品质量安全。</p>
			</div>
			<div class="fwbox1">
				<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
				<p class="nc_p4" data-aos="fade-up">外箱</p>
				<div class="tb_box flex2" data-aos="fade-up">
					<div class="tb_item flex2" @click="bbact=0" :class="bbact==0?'tab_act':''">
						<span>版本一</span>
						<img v-if="bbact!=0" src="@/images/fangwei/kg1.png">
						<img v-if="bbact==0" src="@/images/fangwei/kg2.png">
					</div>
					<div class="tb_item flex2" @click="bbact=1" :class="bbact==1?'tab_act':''">
						<span>版本二</span>
						<img v-if="bbact!=1" src="@/images/fangwei/kg1.png">
						<img v-if="bbact==1" src="@/images/fangwei/kg2.png">
					</div>
					<div class="tb_item flex2" @click="bbact=2" :class="bbact==2?'tab_act':''">
						<span>版本三</span>
						<img v-if="bbact!=2" src="@/images/fangwei/kg1.png">
						<img v-if="bbact==2" src="@/images/fangwei/kg2.png">
					</div>
				</div>
			</div>
			<!-- 版本1 -->
			<div v-if="bbact==0 || bbact==2">
				<div class="fwbox1">
					<div class="nc_d1" data-aos="fade-up">
						<div class="swiper_wrap">
							<swiper class="swiper_box1" :options="swiperOption" ref="mySwiper" @slideChange="onSlideChange">
								<swiper-slide v-if="bbact != 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/fwx1.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">新型胶带撕开效果</p>
										<div class="slrt_p2">
											2024年11月起，全面启用新的防伪胶带，新胶带揭开后，在酒箱上留下“已开封”字样。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide v-if="bbact != 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/fwx2.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱顶部</p>
										<div class="slrt_p2">
											剑南春外箱顶部印刷有客户代码、生产日期以及批次和版本信息。注意观察logo颜色是否饱满，图案边缘是否清晰，细节处理是否得当。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide v-if="bbact == 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb01.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱顶部</p>
										<div class="slrt_p2">
											剑南春外箱顶部印刷有客户代码、生产日期以及批次和版本信息。注意观察logo颜色是否饱满，图案边缘是否清晰，细节处理是否得当。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide v-if="bbact == 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb02.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱侧面</p>
										<div class="slrt_p2">
											外箱侧面贴有物流标，物流标所示生产时间与箱内每瓶酒为对应关系，物流标下部24位物流码也可通过我公司内部数据库进行查询。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide v-if="bbact == 2" class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb03.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱防伪标</p>
										<div class="slrt_p2">
											二维码扫描外箱防伪标可查询产品真伪信息，将扫描结果与外箱防伪标进行核对，逐一观察彩色亮片的分布位置、数量是否相符，若相符则说明是真品，并且，彩色亮片可用针或者刀尖挑出，非印刷墨迹，请注意区别。
										</div>
									</div>
								</swiper-slide>
							</swiper>
							<div class="change_box flex1" :style="{ width: bbact == 2 ? '350px' : '260px' }">
								<img @click="slidChange(1)" src="@/images/fangwei/left1.png" />
								<div class="change_tab flex3">
									<span v-if="bbact != 2" @click="slidChange2(0)" :class="actIndex == 0 ? 'pc_act1' : ''">新型胶带</span>
									<span v-if="bbact != 2" @click="slidChange2(1)" :class="actIndex == 1 ? 'pc_act1' : ''">外箱顶部</span>
									<span v-if="bbact == 2" @click="slidChange2(0)" :class="actIndex == 0 ? 'pc_act1' : ''">外箱顶部</span>
									<span v-if="bbact == 2" @click="slidChange2(1)" :class="actIndex == 1 ? 'pc_act1' : ''">外箱侧面</span>
									<span v-if="bbact == 2" @click="slidChange2(2)" :class="actIndex == 2 ? 'pc_act1' : ''">外箱防伪标</span>
								</div>
								<img @click="slidChange(2)" src="@/images/fangwei/right1.png" />
							</div>
						</div>
					</div>
				</div>
				<div class="fwbox2">
					<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
					<p class="nc_p4" data-aos="fade-up">外盒</p>
					<div class="carton_wrap" data-aos="fade-up">
					<ul class="flex1 carton_box" :class="{ carton_box_two: bbact == 2 }">
							<li class="carton_item">
								<div class="tm_con">
									<img :src="bbact == 2 ? require('@/images/fangwei/bb1.png') : require('@/images/fangwei/jiu1.png')" />
									<p>2020版剑南春正面图</p>
								</div>
							</li>
							<li class="carton_item">
								<div class="tm_con">
									<img :src="bbact == 2 ? require('@/images/fangwei/bb2.png') : require('@/images/fangwei/jiu2.png')" />
									<p>2020版剑南春侧面图</p>
								</div>
							</li>
							<li v-if="bbact != 2" class="carton_item">
								<div class="tm_con">
									<img src="@/images/fangwei/jiu3.png" />
									<p>2020版剑南春侧面图</p>
								</div>
							</li>
						</ul>
						<div v-if="bbact != 2" class="secbox3">
							<ul class="seclist2">
								<li class="st_box1 flex1" data-aos="fade-up">
									<div class="st_left">
										<img src="@/images/fangwei/fwx4.png" />
									</div>
									<div class="st_right">
										<div class="lt_box">
											<p class="lt_p1">剑南春外盒物流码</p>
											<p class="lt_p2">
												剑南春酒盒侧面破坏性拉环下方红色底盒上有一组激光烧刻的24位物流号码，在物流码下方红色底盒上烧刻了生产日期，一箱内六盒酒均为同一日期，并与外箱顶部生产日期一致。
											</p>
										</div>
									</div>
								</li>
								<li class="st_box1 flex1" data-aos="fade-up">
									<div class="st_right">
										<div class="lt_box">
											<p class="lt_p1">外盒防伪标</p>
											<p class="lt_p2">
												微信扫描防伪标二维码，可查询到产品的批次、生产日期以及经销商信息。将扫描结果与实物进行对比，核对实物标识的文字、图案是否与之相符：防伪标识上有彩色亮片，手摸有凸感，右侧红色温变线遇热褪色，实物标识与存档图亮片的颜色、位置相符，并且可挑出，若不符则防伪标识为假冒。请注意甄别。
											</p>
										</div>
									</div>
									<div class="st_left">
										<img src="@/images/fangwei/fwx5.png" />
									</div>
								</li>
							</ul>
						</div>
						<template v-else>
							<div class="secbox3 secbox3_version_three" style="margin-top: -4px;">
								<ul class="seclist2">
									<li class="st_box1 flex1" data-aos="fade-up">
										<div class="st_left">
											<img src="@/images/fangwei/bb3.png" />
										</div>
										<div class="st_right">
											<div class="lt_box">
												<p class="lt_p1">剑南春外盒物流码</p>
												<p class="lt_p2">
													剑南春酒盒侧面破坏性拉环下方红色底盒上有一组激光烧刻的24位物流号码，在物流码下方红色底盒上烧刻了生产日期，一箱内六盒酒均为同一日期，并与外箱顶部生产日期一致。
												</p>
											</div>
										</div>
									</li>
								</ul>
							</div>
							<div class="secbox3 secbox3_version_three">
								<ul class="seclist2">
									<li class="st_box1 flex1" data-aos="fade-up">
										<div class="st_right">
											<div class="lt_box">
												<p class="lt_p1">外盒防伪标</p>
												<p class="lt_p2">综合全息防伪技术</p>
												<p class="lt_p2">· 裸眼3D效果 · 猫眼效果 · 景深文字清晰：背景虚化</p>
												<p class="lt_p2">· 铂金浮雕：Logo为立体浮雕效果</p>
												<p class="lt_p2 lt_p2_hanging">· 菲涅尔透镜+微缩文字：用20倍以上放大镜观察可见“唐时宫廷酒 今日剑南春”文字</p>
												<p class="lt_p2">· 动态追焦：“JNC”文字随点光源动态移动</p>
												<p class="lt_p2">· 3D翻转动态效果 · 专用防伪版纹 · 锯齿二维码</p>
												<p class="lt_p2">· 磁性3D油墨：晃动标签，剑南春字体会有金色光柱闪动</p>
												<p class="lt_p2 lt_p2_hanging">· 无色荧光（变黄）：常光下无色，荧光显现黄色“JNC”字样</p>
												<p class="lt_p2 lt_p2_hanging">· 局部随机纹理（彩色亮片+绒毛纤维）：专用设备制作出随机分布的防伪纤维层，具有唯一性特征</p>
												<p class="lt_p2 lt_p2_hanging">· 全息烫印随机图案：全新AI自动识别技术，手机扫码，根据提示操作，自动鉴别真伪</p>
											</div>
										</div>
										<div class="st_left">
											<img src="@/images/fangwei/bb4.png" />
										</div>
									</li>
								</ul>
							</div>
						</template>
					</div>
				</div>
				<div class="fwbox3">
					<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
					<p class="nc_p4" data-aos="fade-up">酒瓶</p>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img :src="bbact == 2 ? require('@/images/fangwei/bb5.png') : require('@/images/fangwei/fwx6.png')" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">瓶盖</p>
										<p class="lt_p2">
											采用二维码喷印瓶盖，扫描可获取产品促销活动信息。瓶盖上有激光烧刻24位物流码、生产日期及产品批号。
										</p>
									</div>
								</div>
							</li>
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">酒瓶纹理防伪标</p>
										<p v-if="bbact != 2" class="lt_p2">
											纹理防伪标采用热敏防伪技术，加热后会出现“加热失效”字样。还可通过拨打400-6800315，按语音提示操作，进行真伪查询。同时也可通过网络查询真伪，进入拍拍看<a
												href="https://www.315net.com"
												target="_blank">www.315net.com</a>，按页面提示输入序号，将查询到的信息与实物核对，若不符，则防伪标识为假冒。
										</p>
										<template v-else>
											<p class="lt_p2">· 不可逆温变油墨：加热到70°C后显现“变色失效”字样</p>
											<p class="lt_p2 lt_p2_hanging">· 磁性3D油墨：晃动标签，“剑南春”字体会有金色光柱闪动</p>
											<p class="lt_p2">· 专用防伪版纹：“JNC”立体浮雕</p>
											<p class="lt_p2 lt_p2_hanging">· 全息烫印随机图案：全息图案包含激光彩虹效果和随机可变数字、</p>
											<p class="lt_p2">· 无色荧光(黄)：荧光灯照射显现黄色“JNC”字样</p>
											<p class="lt_p2 lt_p2_hanging">· 局部随机纹理(彩色亮片+绒毛纤维)：专用设备制作出随机分布的防伪纤维层，具有唯一性特征</p>
										</template>
									</div>
								</div>
								<div class="st_left">
									<img :src="bbact == 2 ? require('@/images/fangwei/bb6.png') : require('@/images/fangwei/fwx7.png')" />
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div v-if="bbact != 2" class="fwbox4">
					<p class="nc_p3" data-aos="fade-up">膜类防伪标识别</p>
					<p class="nc_p4" data-aos="fade-up">外盒</p>
					<ul class="flex1 wh_ul">
						<li class="wh_li">
							<div class="tm_con" data-aos="fade-up">
								<img src="@/images/fangwei/jiu4.png" />
								<p>正面图</p>
							</div>
						</li>
						<li class="wh_li">
							<div class="tm_con" data-aos="fade-up">
								<img src="@/images/fangwei/jiu5.png" />
								<p>侧面图</p>
							</div>
						</li>
					</ul>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx8.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">外盒防伪标</p>
										<p class="lt_p2">
											1.不同角度下，“剑南春”的颜色不一样
										</p>
										<p class="lt_p2">
											2.强光照射中部区域，变换角度，可见“剑南春”三个字
										</p>
										<p class="lt_p2">
											3.不同角度下，可见金色到彩亮的变化
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div v-if="bbact != 2" class="fwbox5">
					<p class="nc_p3" data-aos="fade-up">膜类防伪标识别</p>
					<p class="nc_p4" data-aos="fade-up">酒瓶</p>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx9.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">瓶盖防伪标</p>
										<p class="lt_p2">
											1.强光照射下，变换角度，可见“JNC”三个字母
										</p>
										<p class="lt_p2">
											2.不同角度下，“剑南春”的颜色不一样
										</p>
										<p class="lt_p2">
											3.用手触摸标签圆形纤维有凹凸感挑，可挑出圆形纤维膜类防伪标查询电话为：4008161365
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<!-- 版本2 -->
			<div v-if="bbact==1">
				<div class="fwbox1">
					<div class="nc_d1" data-aos="fade-up">
						<div class="swiper_wrap">
							<swiper class="swiper_box1" :options="swiperOption" ref="mySwiper" @slideChange="onSlideChange">
								<swiper-slide class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb_img1.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱顶部</p>
										<div class="slrt_p2">
											剑南春外箱顶部印刷有客户代码、生产日期以及批次和版本信息。注意观察logo颜色是否饱满，图案边缘是否清晰，细节处理是否得当。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb_img2.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱侧面</p>
										<div class="slrt_p2">
											外箱侧面贴有物流标，物流标所示生产时间与箱内每瓶酒为对应关系，物流标下部24位物流码也可通过我公司内部数据库进行查询。
										</div>
									</div>
								</swiper-slide>
								<swiper-slide class="slid_item flex1">
									<div class="sl_left">
										<img src="@/images/fangwei/bb_img3.png" />
									</div>
									<div class="sl_right">
										<p class="slrt_p1">外箱防伪标</p>
										<div class="slrt_p2">
											二维码扫描外箱防伪标可查询产品真伪信息，将扫描结果与外箱防伪标进行核对，逐一观察彩色亮片的分布位置、数量是否相符，若相符则说明是真品，并且，彩色亮片可用针或者刀尖挑出，非印刷墨迹，请注意区别。
										</div>
									</div>
								</swiper-slide>
							</swiper>
							<div class="change_box flex1">
								<img @click="slidChange(1)" src="@/images/fangwei/left1.png" />
								<div class="change_tab flex3">
									<span @click="slidChange2(0)" :class="actIndex == 0 ? 'pc_act1' : ''">外箱顶部</span>
									<span @click="slidChange2(1)" :class="actIndex == 1 ? 'pc_act1' : ''">外箱侧面</span>
									<span @click="slidChange2(2)" :class="actIndex == 2 ? 'pc_act1' : ''">外箱防伪标</span>
								</div>
								<img @click="slidChange(2)" src="@/images/fangwei/right1.png" />
							</div>
						</div>
					</div>
				</div>
				<div class="fwbox2">
					<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
					<p class="nc_p4" data-aos="fade-up">外盒</p>
					<div class="carton_wrap" data-aos="fade-up">
						<ul class="flex1 carton_box">
							<li class="carton_item">
								<div class="tm_con">
									<img src="@/images/fangwei/jiu1.png" />
									<p>2020版剑南春正面图</p>
								</div>
							</li>
							<li class="carton_item">
								<div class="tm_con">
									<img src="@/images/fangwei/jiu2.png" />
									<p>2020版剑南春侧面图</p>
								</div>
							</li>
							<li class="carton_item">
								<div class="tm_con">
									<img src="@/images/fangwei/jiu3.png" />
									<p>2020版剑南春侧面图</p>
								</div>
							</li>
						</ul>
						<div class="secbox3">
							<ul class="seclist2">
								<li class="st_box1 flex1" data-aos="fade-up">
									<div class="st_left">
										<img src="@/images/fangwei/fwx4.png" />
									</div>
									<div class="st_right">
										<div class="lt_box">
											<p class="lt_p1">剑南春外盒物流码</p>
											<p class="lt_p2">
												剑南春酒盒侧面破坏性拉环下方红色底盒上有一组激光烧刻的24位物流号码，在物流码下方红色底盒上烧刻了生产日期，一箱内六盒酒均为同一日期，并与外箱顶部生产日期一致。
											</p>
										</div>
									</div>
								</li>
								<li class="st_box1 flex1" data-aos="fade-up">
									<div class="st_right">
										<div class="lt_box">
											<p class="lt_p1">外盒防伪标</p>
											<p class="lt_p2">
												微信扫描防伪标二维码，可查询到产品的批次、生产日期以及经销商信息。将扫描结果与实物进行对比，核对实物标识的文字、图案是否与之相符：防伪标识上有彩色亮片，手摸有凸感，右侧红色温变线遇热褪色，实物标识与存档图亮片的颜色、位置相符，并且可挑出，若不符则防伪标识为假冒。请注意甄别。
											</p>
										</div>
									</div>
									<div class="st_left">
										<img src="@/images/fangwei/fwx5.png" />
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="fwbox3">
					<p class="nc_p3" data-aos="fade-up">三位一体防伪识别</p>
					<p class="nc_p4" data-aos="fade-up">酒瓶</p>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx6.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">瓶盖</p>
										<p class="lt_p2">
											采用二维码喷印瓶盖，扫描可获取产品促销活动信息。瓶盖上有激光烧刻24位物流码、生产日期及产品批号。
										</p>
									</div>
								</div>
							</li>
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">酒瓶纹理防伪标</p>
										<p class="lt_p2">
											纹理防伪标采用热敏防伪技术，加热后会出现“加热失效”字样。还可通过拨打400-6800315，按语音提示操作，进行真伪查询。同时也可通过网络查询真伪，进入拍拍看<a
												href="https://www.315net.com"
												target="_blank">www.315net.com</a>，按页面提示输入序号，将查询到的信息与实物核对，若不符，则防伪标识为假冒。
										</p>
									</div>
								</div>
								<div class="st_left">
									<img src="@/images/fangwei/fwx7.png" />
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="fwbox4">
					<p class="nc_p3" data-aos="fade-up">膜类防伪标识别</p>
					<p class="nc_p4" data-aos="fade-up">外盒</p>
					<ul class="flex1 wh_ul">
						<li class="wh_li">
							<div class="tm_con" data-aos="fade-up">
								<img src="@/images/fangwei/jiu4.png" />
								<p>正面图</p>
							</div>
						</li>
						<li class="wh_li">
							<div class="tm_con" data-aos="fade-up">
								<img src="@/images/fangwei/jiu5.png" />
								<p>侧面图</p>
							</div>
						</li>
					</ul>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx8.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">外盒防伪标</p>
										<p class="lt_p2">
											1.不同角度下，“剑南春”的颜色不一样
										</p>
										<p class="lt_p2">
											2.强光照射中部区域，变换角度，可见“剑南春”三个字
										</p>
										<p class="lt_p2">
											3.不同角度下，可见金色到彩亮的变化
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="fwbox5">
					<p class="nc_p3" data-aos="fade-up">膜类防伪标识别</p>
					<p class="nc_p4" data-aos="fade-up">酒瓶</p>
					<div class="secbox3">
						<ul class="seclist2">
							<li class="st_box1 flex1" data-aos="fade-up">
								<div class="st_left">
									<img src="@/images/fangwei/fwx9.png" />
								</div>
								<div class="st_right">
									<div class="lt_box">
										<p class="lt_p1">瓶盖防伪标</p>
										<p class="lt_p2">
											1.强光照射下，变换角度，可见“JNC”三个字母
										</p>
										<p class="lt_p2">
											2.不同角度下，“剑南春”的颜色不一样
										</p>
										<p class="lt_p2">
											3.用手触摸标签圆形纤维有凹凸感挑，可挑出圆形纤维膜类防伪标查询电话为：4008161365
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="rd_box">
				<record></record>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isPhone: this.$isMobile,
			bbact: 0,
			actIndex: 0,
			swiperOption: {
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				autoplay: true,
				// mousewheel: true,
				speed: 1000, //切换速度
			},
		};
	},
	methods: {
		slidChange(a) {
			if (a == 1) {
				if (this.actIndex > 0) {
					this.$refs.mySwiper.$swiper.slideTo(this.actIndex - 1);
				}
			} else {
				if (this.actIndex < 2) {
					this.$refs.mySwiper.$swiper.slideTo(this.actIndex + 1);
				}
			}
		},
		slidChange2(a) {
			this.$refs.mySwiper.$swiper.slideTo(a);
		},
		onSlideChange() {
			const swiper = this.$refs.mySwiper.$swiper;
			this.actIndex = swiper.realIndex;
		},
	},
};
</script>

<style lang="scss">
/* 电脑端公共样式开始 */
.pc_act1 {
	font-size: 16px !important;
	color: #333 !important;
	// font-weight: bold;
}
.nc_p3 {
	color: #666;
	font-size: 28px;
	text-align: center;
	margin-bottom: 26px;
	animation-duration: 0.7s;
}
.nc_p4 {
	text-align: center;
	position: relative;
	color: #d43235;
	font-size: 36px;
	font-weight: 700;
	background-image: url("../../images/fangwei/fw1.png");
	background-repeat: no-repeat;
	background-position: bottom;
	margin-bottom: 46px;
	animation-duration: 0.7s;
}
.secbox3 {
	padding: 15px;
	background-color: #fff;
	.seclist2 {
		.st_box1 {
			.st_left {
				width: 50%;
				img {
					display: block;
					width: 100%;
				}
			}
			.st_right {
				width: 50%;
			}
		}
	}
}
.secbox3_version_three {
	margin-top: 10px;
	.seclist2 > .st_box1 + .st_box1 {
		margin-top: 30px;
	}
}
.lt_p1 {
	color: #d43236;
	font-size: 30px;
	position: relative;
	padding-bottom: 16px;
	margin-bottom: 24px;
	text-align: left;
	&::after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		width: 95px;
		height: 3px;
		background-color: #dfd0b8;
	}
}
.lt_p2 {
	color: #333;
	font-size: 18px;
	line-height: 1.8;
	text-align: left;
	a {
		color: #d43235;
		text-decoration: underline;
	}
}
.lt_p2_hanging {
	padding-left: 1em;
	text-indent: -1em;
}
.slrt_p12 {
	padding-left: 0.43rem;
	position: relative;
	color: #666;
	font-size: 0.4rem;
	font-weight: 700;
	text-align: left;
	&::after {
		content: "";
		top: 50%;
		width: 0.21rem;
		height: 0.33rem;
		margin-top: -0.16rem;
		background-color: #f6dfbc;
		left: 0;
		position: absolute;
	}
}
.slrt_p22 {
	color: #666;
	font-size: 0.37rem;
	margin-top: 0.24rem;
	line-height: 1.8;
	text-align: left;
	a {
		color: #d43235;
		text-decoration: underline;
	}
}
.lt_box {
	max-width: 460px;
	margin: 0 auto;
}
/* 电脑端公共样式结束*/
.ph_act1 {
	background-color: #fff !important;
}
.se_all {
	@font-face {
		font-family: "SourceHanSans";
		src: url("../../font/SourceHanSansCN-Regular.otf");
	}
	font-family: "SourceHanSans";
	width: 100%;
	min-height: 900px;
	background-image: url("../../images/bgimg3.png");
	.news_pc {
		max-width: 1200px;
		margin: 0 auto;
		padding: 136px 0 85px;
		min-width: 900px;
		.page_tit {
			.nc_p1 {
				text-align: center;
				color: #c0494b;
				font-size: 36px;
				margin-bottom: 46px;
				font-weight: 700;
				animation-duration: 0.7s;
			}
			.nc_p2 {
				text-align: center;
				color: #333;
				font-size: 18px;
				margin-bottom: 80px;
				animation-duration: 0.7s;
			}
		}
		.fwbox1 {
			.nc_d1 {
				background-color: #fff;
				overflow: hidden;
				padding: 15px 56px 15px 15px;
				position: relative;
				margin-bottom: 84px;
				.swiper_wrap {
					position: relative;
					.swiper_box1 {
						.slid_item {
							.sl_left {
								width: 50%;
								img {
									width: 100%;
								}
							}
							.sl_right {
								width: 50%;
								flex: 1;
								padding-left: 86px;
								padding-bottom: 50px;
								.slrt_p1 {
									color: #d43236;
									font-size: 30px;
									padding-bottom: 16px;
									margin-bottom: 24px;
									position: relative;
									text-align: left;
									&::after {
										content: "";
										position: absolute;
										left: 0;
										bottom: 0;
										width: 95px;
										height: 3px;
										background-color: #dfd0b8;
									}
								}
								.slrt_p2 {
									text-align: left;
									color: #333;
									font-size: 18px;
									line-height: 1.8;
								}
							}
						}
					}
					.change_box {
						position: absolute;
						bottom: 15px;
						right: 20px;
						z-index: 19;
						width: 350px;
						img {
							width: 32px;
							cursor: pointer;
						}
						.change_tab {
							flex: 1;
							justify-content: space-around;
							align-items: flex-end;
							margin-bottom: 3px;
							padding: 0 10px;
							span {
								font-size: 14px;
								cursor: pointer;
								color: #555;
								margin-bottom: 2px;
								white-space: nowrap;
							}
						}
					}
				}
			}
			.tab_act {
				background-color: #efe2d2;
				span {
					color: #d43236 !important;
				}
			}
			.tb_box {
				margin-bottom: 44px;
				.tb_item {
					width: 164px;
					height: 62px;
					position: relative;
					cursor: pointer;
					&:nth-child(2),
					&:nth-child(3) {
						margin-left: 80px;
					}
					img {
						position: absolute;
						left: 0;
						width: 164px;
						height: 62px;
					}
					span {
						font-size: 28px;
						color: #555;
						margin-bottom: 3px;
					}
				}
			}
		}
		.fwbox2 {
			.carton_wrap {
				margin-bottom: 80px;
				.carton_box {
					.carton_item {
						width: 29.5%;
						padding: 15px;
						margin-bottom: 15px;
						background-color: #fff;
						.tm_con {
							background-color: #f3f3f3;
							padding: 22px 15px 16px;
							img {
								height: 240px;
							}
							p {
								text-align: center;
								color: #d43236;
								font-size: 20px;
								padding-top: 18px;
								margin-top: 40px;
								position: relative;
								&::after {
									content: "";
									position: absolute;
									top: 0;
									left: 50%;
									width: 80px;
									height: 3px;
									background-color: #dfd0b8;
									margin-left: -40px;
								}
							}
						}
					}
					&.carton_box_two {
						justify-content: space-between;
						gap: 2%;
						.carton_item {
							width: 49%;
							box-sizing: border-box;
						}
					}
					.ctm2 {
						width: 47%;
						.tm_con {
							padding: 0 15px 16px;
							img {
								height: 331px;
							}
							p {
								font-size: 28px;
								margin-top: 20px;
								&::after {
									content: "";
									position: absolute;
									top: 0;
									left: 50%;
									width: 80px;
									height: 3px;
									background-color: #dfd0b8;
									margin-left: -40px;
								}
							}
						}
					}
				}
			}
		}
		.fwbox4 {
			margin-top: 80px;
			.wh_ul {
				.wh_li {
					width: 46.5%;
					padding: 15px;
					margin-bottom: 30px;
					background-color: #fff;
					.tm_con {
						background-color: #f3f3f3;
						padding: 22px 15px 16px;
						img {
							height: 240px;
						}
						p {
							text-align: center;
							color: #d43236;
							font-size: 20px;
							padding-top: 18px;
							margin-top: 40px;
							position: relative;
							&::after {
								content: "";
								position: absolute;
								top: 0;
								left: 50%;
								width: 80px;
								height: 3px;
								background-color: #dfd0b8;
								margin-left: -40px;
							}
						}
					}
				}
			}
		}
		.fwbox5 {
			margin-top: 80px;
		}
		.rd_box {
			margin-top: 60px;
		}
	}
}
</style>
